/**
 * Functions to manipulate with DOM
 */


/**
 * Scroll to top of the document
 */
export const scrollToTop = () => {
  window.scrollTo(0, 0);
};


/**
 * Scroll to block with validation messages
 */
export const scrollToValidation = () => {
  const el = document.querySelector('#oncourse-checkout .validation') as HTMLElement;
  window.scrollTo(0, offset(el).top - 5);
};


/**
 * Get element offsetTop
 */
const offset = (el: HTMLElement): {top: number} => {
  if (!el) return {top: 0};

  const rect = el.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {top: rect.top + scrollTop};
};

export const findPriceInDOM = (code): number => {
  const priceContainer = document.querySelector(`[data-classid="${code}"] [class="fee"]`);
  let price;

  if(priceContainer) {
    price = parseFloat(priceContainer.innerHTML.replace(/[^\d.]/g,""));
  }

  return price;
}

export const attachScript = (url: string, onLoad?: () => void, place: 'bottom' | 'top' = 'bottom') => {
  if (document.querySelector(`script[src="${url}"]`)) return;
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  if (onLoad) {
    script.addEventListener("load", onLoad);
  }
  switch (place) {
    case 'bottom':
      document.head.append(script);
      break;
    case 'top':
      document.head.prepend(script);
      break;
  }
};

export const attachScriptHTML = (html: string,  place: 'bottom' | 'top' = 'bottom') => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.innerHTML = html;
  switch (place) {
    case 'bottom':
      document.head.append(script);
      break;
    case 'top':
      document.head.prepend(script);
      break;
  }
};